<template>
  <section v-loading.fullscreen.lock="loading">
    <div class="term0">
      <div class="term0-top">
        <div class="term0-top-title">
          <img :src="require(`@/assets/statistics/school1.png`)" alt="" />
          <span>学校基本信息</span>
        </div>
        <div class="term0-top-form">
          <el-form ref="form" :model="form">
            <el-form-item>
              <span class="term0-top-form-span">学校全称：</span>
              <el-input class="wid25" v-model="form.name"></el-input>
              <span class="term0-top-form-span">学校代码：</span>
              <el-input class="wid25" v-model="form.code"></el-input>
            </el-form-item>
            <el-form-item>
              <span class="term0-top-form-span">学校类别：</span>
              <el-select v-model="form.kind" placeholder="请选择">
                <el-option
                  v-for="item in statisticsInfo.obj.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <span class="term0-top-form-span">办学性质：</span>
              <el-select v-model="form.nature" placeholder="请选择">
                <el-option
                  v-for="item in statisticsInfo.obj.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <span class="term0-top-form-span">申报时间：</span>
              <el-date-picker
                v-model="form.time"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
              <span class="term0-top-form-span">所在地区：</span>
              <el-select v-model="form.area" placeholder="请选择">
                <el-option
                  v-for="item in statisticsInfo.obj.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <span class="term0-top-form-span">登记负责人：</span>
              <el-input class="wid25" v-model="form.man"></el-input>
              <span class="term0-top-form-span">联系电话：</span>
              <el-input class="wid25" v-model="form.phone"></el-input>
            </el-form-item>
            <el-form-item>
              <span class="term0-top-form-span">详细地址：</span>
              <el-input class="wid75" v-model="form.address"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="term0-bottom">
        <div class="term0-bottom-title">
          <img :src="require(`@/assets/statistics/school1.png`)" alt="" />
          <span>学校规模信息</span>
        </div>
        <div class="term0-bottom-form">
          <el-form ref="form1" :model="form1">
            <el-form-item>
              <div class="term0-bottom-form-ib term0-bottom-form-title">
                学校面积
              </div>
              <div class="term0-bottom-form-ib term0-bottom-form-content">
                <el-input v-model="form1.area"></el-input>
              </div>
              <div class="term0-bottom-form-ib term0-bottom-form-title">
                学校建筑面积
              </div>
              <div class="term0-bottom-form-ib term0-bottom-form-content1">
                <el-input v-model="form1.buildarea"></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="term0-bottom-form-ib term0-bottom-form-title">
                普通教室数量
              </div>
              <div class="term0-bottom-form-ib term0-bottom-form-content">
                <el-input v-model="form1.classroom"></el-input>
              </div>
              <div class="term0-bottom-form-ib term0-bottom-form-title">
                教师办公室（含行政）
              </div>
              <div class="term0-bottom-form-ib term0-bottom-form-content1">
                <el-input v-model="form1.staffroom"></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="term0-bottom-form-ib term0-bottom-form-title">
                在校学生人数
              </div>
              <div class="term0-bottom-form-ib term0-bottom-form-content">
                <el-input v-model="form1.inschoolnum"></el-input>
              </div>
              <div class="term0-bottom-form-ib term0-bottom-form-title">
                教职工人数
              </div>
              <div class="term0-bottom-form-ib term0-bottom-form-content1">
                <el-input v-model="form1.staffnum"></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="term0-bottom-form-ib term0-bottom-form-title">
                数理化实验室
              </div>
              <div class="term0-bottom-form-ib term0-bottom-form-content">
                <el-input v-model="form1.lab"></el-input>
              </div>
              <div class="term0-bottom-form-ib term0-bottom-form-title">
                音体美卫教室
              </div>
              <div class="term0-bottom-form-ib term0-bottom-form-content1">
                <el-input v-model="form1.ytmwroom"></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="term0-bottom-form-ib term0-bottom-form-title">
                信息化设备
              </div>
              <div class="term0-bottom-form-ib term0-bottom-form-content">
                <el-input v-model="form1.equip"></el-input>
              </div>
              <div class="term0-bottom-form-ib term0-bottom-form-title">
                课桌椅校服
              </div>
              <div class="term0-bottom-form-ib term0-bottom-form-content1">
                <el-input v-model="form1.uniform"></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="term0-bottom-form-ib term0-bottom-form-title term0-bottom-form-bb">
                食堂设施
              </div>
              <div class="term0-bottom-form-ib term0-bottom-form-content term0-bottom-form-bb">
                <el-input v-model="form1.canteen"></el-input>
              </div>
              <div class="term0-bottom-form-ib term0-bottom-form-title term0-bottom-form-bb">
                图书馆
              </div>
              <div class="term0-bottom-form-ib term0-bottom-form-content1 term0-bottom-form-bb">
                <el-input v-model="form1.library"></el-input>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import mock from "@/utils/mock";
export default {
  name: "comTerm0",
  components: {},
  props: {},
  computed: {},
  watch: {},
  data() {
    return {
      loading: false,
      statisticsInfo: mock.statistics.statistics.viewInfo,
      statisticsInit: mock.statistics.statistics.init,
      form: {
        sc: "",
        code: "",
        kind: "",
        nature: "",
        time: "",
        area: "",
        man: "",
        phone: "",
        address: "",
      },
      form1: {
        area: "",
        buildarea:'',
        classroom:'',
        staffroom:'',
        inschoolnum:'',
        staffnum:'',
        lab:'',
        ytmwroom:'',
        equip:'',
        uniform:'',
        canteen:'',
        library:''
      },
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.term0 {
  min-height: 720px;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  &-top {
    &-title {
      padding: 20px 0 0 20px;
      > span {
        color: #2f82ff;
        font-weight: bold;
        margin-left: 10px;
      }
    }
    &-form {
      .el-form {
        width: 75%;
        margin-top: 30px;
      }
      .wid25 {
        width: 217px;
      }
      &-span {
        display: inline-block;
        width: 150px;
        text-align: right;
      }
      .wid75 {
        width: 73.5%;
      }
    }
  }
  &-bottom {
    &-title {
      padding: 50px 0 10px 20px;
      > span {
        color: #2f82ff;
        font-weight: bold;
        margin-left: 10px;
      }
    }
    &-form {
      margin: 30px 70px;
      &-ib {
        display: inline-block;
      }
      &-title {
        width: 180px;
        text-align: center;
        border: 1px solid #cbcbcb;
        background-color: #fafafa;
        border-bottom: none;
        height: 50px;
    line-height: 50px;
      }
      &-content {
        width: 250px;
        border: 1px solid #cbcbcb;
        border-left: none;
        border-right: none;
        border-bottom: none;
        height: 50px;
    line-height: 50px;
      }
      &-content1 {
        width: 250px;
        border: 1px solid #cbcbcb;
        border-left: none;
        border-bottom: none;
        height: 50px;
    line-height: 50px;
      }
      &-bb{
        border-bottom: 1px solid #cbcbcb;
      }
    }
  }
}
/deep/ .el-input__inner {
  height: 35px;
  line-height: 35px;
}
.term0-bottom-form-content1 /deep/ .el-input__inner {
  border: none;
}
.term0-bottom-form-content /deep/ .el-input__inner {
  border: none;
}
.term0-bottom-form /deep/ .el-form-item{
  margin-bottom: 0;
  color: #444;
}
</style>
